import { EInternalUserType, INTERNAL_USER_TYPE_OPTIONS_MAP } from './constants';

export const hydrateFormDataForAdd = (data: any) => {
	const userData = {
		...data
	};
	if (data.ut === EInternalUserType.INTERNAL_WITH_RESTRICTION) {
		userData.ut = INTERNAL_USER_TYPE_OPTIONS_MAP[EInternalUserType.INTERNAL_WITH_RESTRICTION];
	} else {
		userData.ut = INTERNAL_USER_TYPE_OPTIONS_MAP[EInternalUserType.INTERNAL_WITH_WHITELIST];
	}
	delete userData.e;
	delete userData.et;
	return userData;
};

export const dehydrateFormDataForAdd = (formData: any) => {
	const userData = {
		officialEmail: formData.oe,
		managerName: formData.managerName,
		entity: formData.e,
		entityType: formData.et
	};
	return userData;
};
export const dehydrateFormDataForEdit = (formData: any) => {
	const userData = {
		userType: EInternalUserType[formData.ut],
		officialEmail: formData.oe,
		managerName: formData.managerName
	};
	return userData;
};
